import axios from '@/axios'

const tradeinfo = {
  //获取持仓列表  /transaction/userPositions
  async getPositionsList(params) {
    return await axios.get('/uc/api/transaction/userPositions', params, { des: '直客pc获取持仓列表', sTime: new Date().getTime() })
  },
  //获取用户平仓列表 /uc/api/transaction/userClosePositions
  async getClosePositions(params) {
    return await axios.get('/uc/api/transaction/userClosePositions', params, { des: '直客pc获取用户平仓列表', sTime: new Date().getTime() })
  },
}

export default tradeinfo



// WEBPACK FOOTER //
// ./src/api/tradeinfo.js